"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowDown = function () {
    return (react_1["default"].createElement("svg", { width: "15", height: "8", viewBox: "0 0 15 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1["default"].createElement("path", { d: "M13.44 1.71252L8.55 6.60253C7.9725 7.18003 7.0275 7.18003 6.45 6.60253L1.56 1.71252", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports["default"] = ArrowDown;
//# sourceMappingURL=arrowDown.js.map